






export const classesData=new WeakMap;


export const instancesData=new WeakMap;